import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from 'src/app/service/user.service';
import { MatSnackBar } from '@angular/material';
import { AuthService } from 'src/app/service/auth.service';
import { User } from 'src/app/model/user.model';
import { HttpErrorResponse } from '@angular/common/http';
import { Role } from 'src/app/model/role.model';
import { DialogService } from 'src/app/service/dialog.service';
import { TranslationService } from 'src/app/service/translate.service';
import { TranslationPipe } from 'src/app/pipes/translation.pipe';

export function MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      return;
    }

    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}
export interface UserType {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})


export class RegisterComponent implements OnInit {
  registerForm: FormGroup;
  formSubmitAttempt = false;
  userType: FormControl;
  title: string;
  bacgroundContent: string;
  dialogService: DialogService;
  user: User;
  error = '';
  currentUser: User;
  fxLayoutAlign: string;
  checkCaptch = false;

  userTypes: UserType[] = [
    { value: 'Admin', viewValue: 'Admin' },
    { value: 'User', viewValue: 'User' },
    { value: 'Instructor', viewValue: 'Instructor' }
  ];

  @ViewChild('recaptcha', { static: true }) recaptchaElement: ElementRef;
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private userService: UserService,
    private snackBar: MatSnackBar,
    public authService: AuthService,
    dialogService: DialogService,
    public translationService: TranslationService,
    private translationPipe: TranslationPipe) {
    this.dialogService = dialogService;
    this.authService.currentUser.subscribe(x => this.currentUser = x);
  }

  ngOnInit() {
    if (!this.isLoggedIn) {
      this.addRecaptchaScript();
    }
    if (this.authService.currentUserValue == null) {
      this.title = 'Please register to continue';
      this.bacgroundContent = 'bacground-content';
      this.fxLayoutAlign = 'center center';
    } else {
      this.bacgroundContent = '';
      this.fxLayoutAlign = 'start';
    }
    this.initRegisterForm();
  }

  renderReCaptch() {
    window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
      'sitekey': '6LeGf8IUAAAAABQIuEa1HYNVO9y8YNI7XifuTO6z',
      'callback': (response) => {
        if (response == '') {
          this.checkCaptch = false;
        }
        else {
          this.checkCaptch = true;
        }
      }
    });
  }

  addRecaptchaScript() {

    window['grecaptchaCallback'] = () => {
      this.renderReCaptch();
    }

    (function (d, s, id, obj) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { obj.renderReCaptch(); return; }
      js = d.createElement(s); js.id = id;
      js.src = 'https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));

  }

  get isAdmin() {
    return this.currentUser && this.currentUser.role === Role.Admin;
  }

  get isLoggedIn() {
    if (this.authService.currentUserValue != null) {
      return true;
    } else {
      return false;
    }
  }

  CheckValidation(): boolean {
    if (!this.registerForm.valid || !this.userType.valid) {
      this.error = this.translationPipe.transform('msgReservationAddMandatoryFieds');
      return false;
    }
    if (this.authService.currentUserValue == null && (!this.checkCaptch || grecaptcha.getResponse().length === 0)) {
        this.error = this.translationPipe.transform('msgReservationAddMandatoryFieds');
        return false;
    }
    return true;
  }


  initRegisterForm() {
    this.userType = new FormControl('', this.authService.currentUserValue != null ? Validators.required : Validators.nullValidator);
    this.registerForm = this.fb.group(
      {
        name: ['', Validators.required],
        lastName: ['', Validators.required],
        phone: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        username: ['', Validators.required],
        password: ['', Validators.required],
        confirmPassword: ['', Validators.required]
      },
      { validator: MustMatch('password', 'confirmPassword') }
    );
  }

  get f() {
    return this.registerForm.controls;
  }

  isFieldInvalid(field: string) {
    return (!this.registerForm.get(field).valid && this.registerForm.get(field).touched) ||
      (this.registerForm.get(field).untouched && this.formSubmitAttempt);
  }

  cancel() {
    this.router.navigateByUrl('/');
  }

  addUser() {
/*     if (this.CheckValidation()) { */
  if (this.registerForm.valid){
      this.user = new User();
      this.user.name = this.registerForm.value.name;
      this.user.lastName = this.registerForm.value.lastName;
      this.user.password = this.registerForm.value.password;
      this.user.phone = this.registerForm.value.phone;
      this.user.email = this.registerForm.value.email;
      this.user.username = this.registerForm.value.username;
      this.user.role = this.userType.value as Role;


      this.userService.addUser(this.user).subscribe(res => {
          this.dialogService
          .showMessage(
            this.translationPipe.transform('lblAccount'),
            this.translationPipe.transform('msgAccountCreatedSuccessfully'));
          this.router.navigateByUrl('/');
        }, error => this.error = error);
    }
  }

  changeLang() {
    this.translationService.changeLang();
  }
}
